import EnergyDashboardContainer from './containers/EnergyDashboardContainer';

export default EnergyDashboardContainer;
